module.exports = __webpack_public_path__ + "static/media/logo_esn_nl.d7b86af4.svg";